import React from 'react'
import { useTheme } from '../context/ThemeContext'

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme()
  const isDark = theme === 'dark'

  return (
    <button
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      style={{
        position: 'relative',
        width: '52px',
        height: '28px',
        borderRadius: '100px',
        border: '1px solid var(--border-medium)',
        background: isDark ? 'rgba(99,211,183,0.12)' : 'rgba(240,192,96,0.18)',
        cursor: 'pointer',
        transition: 'background 0.35s ease, border-color 0.35s ease',
        flexShrink: 0,
        outline: 'none',
        display: 'flex',
        alignItems: 'center',
        padding: '3px'
      }}
    >
      <span
        aria-hidden='true'
        style={{
          position: 'absolute',
          top: '3px',
          left: isDark ? '3px' : 'calc(100% - 25px - 3px)',
          width: '22px',
          height: '22px',
          borderRadius: '50%',
          background: isDark
            ? 'linear-gradient(135deg, #63d3b7, #38bdf8)'
            : 'linear-gradient(135deg, #f0c060, #f97316)',
          transition: 'left 0.35s cubic-bezier(0.16,1,0.3,1), background 0.35s ease',
          boxShadow: isDark ? '0 2px 8px rgba(99,211,183,0.45)' : '0 2px 8px rgba(240,192,96,0.55)'
        }}
      />
      <span
        aria-hidden='true'
        style={{
          position: 'absolute',
          right: '5px',
          fontSize: '11px',
          opacity: isDark ? 1 : 0,
          transition: 'opacity 0.2s ease',
          lineHeight: 1,
          userSelect: 'none'
        }}
      >
        🌙
      </span>
      <span
        aria-hidden='true'
        style={{
          position: 'absolute',
          left: '5px',
          fontSize: '11px',
          opacity: isDark ? 0 : 1,
          transition: 'opacity 0.2s ease',
          lineHeight: 1,
          userSelect: 'none'
        }}
      >
        ☀️
      </span>
    </button>
  )
}

export default ThemeToggle
